document.addEventListener('DOMContentLoaded', () => {
    let tabs_links = document.querySelectorAll('#active_admin_content .tabs a');
    let current_hash, new_hash;
    tabs_links.forEach(function (e) {
        e.addEventListener("click", function () {
            current_hash = window.location.href.split('#')[1];
            new_hash = this.href.split('#')[1];

            if (current_hash !== undefined && new_hash !== undefined && current_hash !== new_hash) {
                location.replace(this.href);
            }
        });
    });
});
